import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const tokenService = inject(TokenService);

  if (request.params.get('ignorePrefix') === 'true') {
    const params = request.params.delete('ignorePrefix');
    const cleanRequest = request.clone({ params });
    return next(cleanRequest);
  }

  const token = tokenService.getToken();

  if (!token) {
    return next(request);
  }

  const authReq = request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`),
  });

  return next(authReq);
};
